export default {
  clientToken: sessionStorage.getItem('clientToken') || '',
  refreshToken: sessionStorage.getItem('refreshToken') || '',
}
